import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useCustomPageRequest} from '../useCustomPageRequest';
import {ContentBlockSkeleton} from './ContentBlock.skeleton';
import {ContentBlocksView, ContentBlocksViewProps} from './ContentBlocksView';

export const ContentBlocksById: React.FC<
  ContentBlocksViewProps & {pageId?: number}
> = props => {
  const request = useCustomPageRequest({
    pageId: props.pageId,
  });

  return (
    <DataFetcher
      request={request}
      View={ContentBlocksView}
      viewProps={props}
      Loading={ContentBlockSkeleton}
      Error={() => null}
    />
  );
};
